import React, { useState } from 'react';
import axios from 'axios'; 
import { useNavigate } from 'react-router-dom';
import '../index.css';
import Header from '../components/Header';
import Footer from "../components/Footer";
import { Link } from 'react-router-dom';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const loginUser = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post('/php-api/login.php', { email, password });

      if (res.data.user_id) {
        // Save all needed values to localStorage
        localStorage.setItem("isLoggedIn", "true");
        localStorage.setItem("user_id", res.data.user_id); 
        localStorage.setItem("user_name", res.data.user_name || "");
        localStorage.setItem("avatar", res.data.avatar || ""); // Just the filename

        // Trigger event to notify other components
        window.dispatchEvent(new Event("userLogin"));

        navigate('/my-profile');
      } else {
        alert(res.data.message || "Login failed");
      }
    } catch (err) {
      alert('Login failed. Please check your credentials or try again.');
    }
  };

  return (
    <>
      <Header />
       <div className="page-body-container">
      <div className="flex items-center justify-center bg-gray-100 md:py-20 py-10">
        <div className="bg-white rounded-lg shadow-md flex flex-col md:flex-row w-full max-w-4xl">
          {/* Login Form */}
          <div className="w-full md:w-1/2 p-6">
            <h2 className="sm:text-2xl text-xl text-primarycolor font-bold mb-4">LOGIN</h2>
            <form onSubmit={loginUser}>
              <div className="mb-4">
                <label className="block mb-1">Email address*</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="w-full p-2 border rounded bg-gray-100"
                />
              </div>
              <div className="mb-4">
                <label className="block mb-1">Password*</label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="w-full p-2 border rounded bg-gray-100"
                />
              </div> 
              <div className='flex justify-between items-center'>
               <Link to="/ForgotPassword" className="text-green-600 text-sm">Forgotten password?</Link>
              <button
                type="submit"
                className="primarybutton"
              >
                Login
              </button>
              </div>
            </form>
          </div>

          {/* Register Info */}
          <div className="w-full md:w-1/2 p-6 border-t md:border-t-0 md:border-l text-center flex flex-col justify-center">
            <h2 className="sm:text-2xl text-xl text-primarycolor font-bold mb-2">NEW CUSTOMER</h2>
            <p className="mb-4">By creating an account you will be able to shop faster, track orders and more.</p>
           <Link to="/Register" className="primarybutton">Register Now</Link>
          </div>
        </div>
      </div>
      <Footer />
      </div>
    </>
  );
}

export default Login;
